import React from 'react'
import AppBlobCache from '../../AppBlobCache'
import GlobalStorage from "../storage/GlobalStorage";

function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);
  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], {type:mimeString});
}

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {

    }
  }

  render()
  {
    return (
        <span class="ml-2">          
          <input
              id={`jsonImport`}
              type={`file`}
              className={`inputfile`}
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0 && e.target.files[0])
                {
                  var reader = new FileReader();
                  reader.onload = ((theFile) => {
                    return (e) => {
                      let lines = e.target.result;
                      var newArr = JSON.parse(lines);                      
                      

                      //need to reconstruct AppBlobCache here if base64_data is found
                      console.log("!!!!!");
                      console.log(newArr.items);
                      for (var i in newArr.items){
                        
                        if (newArr.items[i].hasOwnProperty('bg') && newArr.items[i].bg._attributes.base64_data){
                          new AppBlobCache().putMediaBlobByKey(
                            `/media/${newArr.items[i].bg._attributes.type}/${newArr.items[i].bg._attributes.src}.${newArr.items[i].bg._attributes.file_ext}`,
                            {
                              ext: newArr.items[i].bg._attributes.file_ext,
                              filename: newArr.items[i].bg._attributes.src,
                              type: newArr.items[i].bg._attributes.type,
                              blob_url: window.URL.createObjectURL(dataURItoBlob(newArr.items[i].bg._attributes.base64_data)),                              
                            });
                        }
                        
                        if (newArr.items[i].hasOwnProperty('media') && newArr.items[i].media._attributes.base64_data){
                          new AppBlobCache().putMediaBlobByKey(
                            `/media/${newArr.items[i].media._attributes.type}/${newArr.items[i].media._attributes.src}.${newArr.items[i].media._attributes.file_ext}`,
                            {
                              ext: newArr.items[i].media._attributes.file_ext,
                              filename: newArr.items[i].media._attributes.src,
                              type: newArr.items[i].media._attributes.type,
                              blob_url: window.URL.createObjectURL(dataURItoBlob(newArr.items[i].media._attributes.base64_data)),                              
                            });
                        }
                        //console.log(new AppBlobCache().getMediaBlobs());
                      }
                      
                      //remove base64_data before importing for debug mode
                      //if (global.DEBUG) newArr = JSON.parse(JSON.stringify(newArr, (k,v) => (k === 'base64_data')? undefined : v));
                      new GlobalStorage().setStoryEpisode(newArr);
                      


                      this.props.onChange && this.props.onChange(e, theFile.name, null);
                    };
                  })(e.target.files[0]);
                  reader.readAsText(e.target.files[0]);
                }
                else
                {
                  this.props.onChange && this.props.onChange(e, null, null);
                }
              }}
          />
          {/*this.props.value*/}
          <label for="jsonImport" class="btn-primary btn mb-0">上載json檔</label>
        </span>
    )
  }
}